module.exports = __webpack_public_path__ + "img/__icon_STANDARD.cd253e9d.svg";